import { WebsiteLevel } from "../types/WebsiteConfig";
import { Config } from "../services/Config";
import { BlogType } from '../types/Blog';

enum BlogOrderBy {
    CreateDateAsc = "CreateDate:Asc",
    CreateDateDesc = "CreateDate:Desc",

    TypeAsc = "Type:Asc",
    TypeDesc = "Type:Desc",

    SuburbAsc = "Suburb:Asc",
    SuburbDesc = "Suburb:Desc"
}

class BlogFilter {
  SearchLevel: WebsiteLevel = Config.API.WebsiteLevel;
  SearchGuid: string = Config.API.WebsiteId;
  
  Suburb: string | null = '';
  Tag: string | null = '';

  Types: BlogType[] = [];

  OrderByStatements: BlogOrderBy[] = [];

  constructor(init?: Partial<BlogFilter>) {
    if(init) Object.assign(this, init);
  }
}

export { BlogFilter, BlogOrderBy }
